import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const current = this.element.querySelector('[aria-current="page"]')
    if (!current || this.element.scrollWidth <= this.element.clientWidth) return
    const parent = this.element.getBoundingClientRect()
    const child = current.getBoundingClientRect()
    this.element.scrollLeft += child.left - parent.left - (parent.width - child.width) / 2
  }
}
